import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  templateUrl: "./unauthorized.component.html",
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {
  // Constructors
  constructor(private router: Router) {
  }

  // Public Methods
  public logout(): void {
    this.router.navigateByUrl('logout');
  }
}
